import React, { useState } from "react";
import InsightArtifactTypeToggle from "../common/InsightArtifactTypeToggle";
import { INSIGHT_TABLE_SWITCH_VALUES } from "../../../constants";

const DiscoveryLayoutShiftingNav = ({selectedTab,setSelectedTab}) => {
    const handleToggle = (
    event: React.MouseEvent<HTMLElement>,
    newSelected: string[]
  ) => {
    if (newSelected?.length > 0) {
      setSelectedTab(newSelected);
    }
  };
  
  return <InsightArtifactTypeToggle
  handleToggle={handleToggle}
  selectedTab={selectedTab}
  component={"toolbar"}
  />;
};
export default DiscoveryLayoutShiftingNav;
